require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
require('controllers');

// require('@fortawesome/fontawesome-free/css/all')

require('lodash/lodash')

// // jQuery setup
// var jQuery = require('jquery');
// global.$ = global.jQuery = jQuery;
// window.$ = window.jQuery = jQuery;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Trix editor setup
require('trix')
require('@rails/actiontext')

// Bootstrap setup
require('bootstrap');
require('admin-lte');
// require('easy-autocomplete');

// Application setup
require('main')
require('datepicker')
require('locations')
require('subject')
require('warehouse')
require('product')

require("trix")
require("@rails/actiontext")